// extracted by mini-css-extract-plugin
export var header = "header-module--header--69b02";
export var headline = "header-module--headline--b0778";
export var subtext = "header-module--subtext--fa9b0";